<template>
  <b-card>
    <div>
      <h1 class="text-center py-2 text-underline">
        Generate Report
      </h1>
      <b-row>
        <b-col
          cols="6"
          class="py-2 text-center"
        >
          <GenerateJeembtn />
        </b-col>
        <b-col
          cols="6"
          class="py-2 text-center"
        >
          <GenerateSFDAbtn />
        </b-col>
        <b-col
          cols="6"
          class="py-2 text-center"
        >
          <GenerateMoiatbtn />
        </b-col>
        <b-col
          cols="6"
          class="py-2 text-center"
        >
          <GenerateSLSbtn />
        </b-col>
        <b-col
          cols="6"
          class="py-2 text-center"
        >
          <GenerateSaberbtn />
        </b-col>
        <b-col
          cols="6"
          class="py-2 text-center"
        >
          <GenerateMOPHbtn />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import GenerateSFDAbtn from './generate-report-btn/GenerateSFDAbtn.vue'
import GenerateJeembtn from './generate-report-btn/GenerateJeembtn.vue'
import GenerateMoiatbtn from './generate-report-btn/GenerateMoiatbtn.vue'
import GenerateSLSbtn from './generate-report-btn/GenerateSLSbtn.vue'
import GenerateSaberbtn from './generate-report-btn/GenerateSaberbtn.vue'
import GenerateMOPHbtn from './generate-report-btn/GenerateMOPHbtn.vue'

export default {
  components: {
    GenerateSFDAbtn,
    GenerateJeembtn,
    GenerateMoiatbtn,
    GenerateSLSbtn,
    GenerateSaberbtn,
    GenerateMOPHbtn,
  },
}
</script>
